import Storage from "@/libs/storage.js";
import emitter from "@/libs/emitter.js";

const storage = new Storage()

const trans = (key, replace = {}, language = null) => {
    let translation

    try {
        translation = key.split('.').reduce((t, i) => t[i] || null, window.translations);
        translation = translation[language || getLanguage()]
    } catch (e) {
        return key
    }

    try {
        for (let placeholder in replace) {
            translation = translation.replace(`:${placeholder}`, replace[placeholder]);
        }
        return translation || key;
    } catch (e) {
        return key;
    }
}

const getLanguage = () => {
    return storage.get('language', 'en');
}

const setLanguage = (lng) => {
    storage.set('language', lng);
    window.axios.defaults.headers.common['Qr-Language'] = lng;
    emitter.emit('languageChanged')
}

const getQueryParam = (property) => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    return params[property]
}

const timeout = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

export {
    trans,
    getLanguage,
    setLanguage,
    getQueryParam,
    timeout,
}
